import React from 'react';

import { StyleSheet } from 'react-native';
import { withTypography } from 'ucl/components/text/Typography';

import { InnerLayout, LayoutContainer } from 'components/layout/styled';
import { Box, BoxProps } from 'components/ui';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';

export const Wrapper = Box;

export const ProductOrderReviewWrapper = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.productOrderReviewWrapper, style]} />
);

export const Container = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.container, style]} />
);

export const ProductTitle = withTypography({
  accessible: true,
  variant: 'headerTwo',
  m: '$0',
  fontSize: '2xl',
  px: '$8',
  textAlign: 'center',
  lineHeight: 33,
  style: { paddingBottom: 12 },
});

export const ProductOrderReviewContainer = ({ style, ...props }: BoxProps) => {
  const isDesktop = useIsDesktopBreakpoint();

  return (
    <Box
      {...props}
      style={[
        styles.productOrderReviewContainer,
        isDesktop && styles.productOrderReviewContainerDesktop,
        style,
      ]}
    />
  );
};

export const ProductReviewLayoutContainer = LayoutContainer.withConfig({
  marginY: 0,
  paddingY: 0,
});

export const ProductOrderReviewInnerLayout = InnerLayout.withConfig({
  marginY: 0,
  paddingY: 0,
});

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    display: 'flex',
    height: 'auto',
    paddingTop: 12,
    width: '100%',
  },
  productOrderReviewContainer: {
    flex: 1,
    margin: 0,
    marginTop: 16,
    padding: 0,
  },
  productOrderReviewContainerDesktop: {
    marginTop: 32,
  },
  productOrderReviewWrapper: {
    flex: 1,
    margin: 0,
    padding: 0,
  },
});
